import React, { useState } from 'react';
import './ContactForm.css';
import '../../App.css';
import Button from '../Button/Button';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faYoutubeSquare, faFacebookF } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';

const ContactForm = ({ isMenuOpen }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const mailtoLink = `mailto:lambadacouncil@gmail.com?subject=Contact Form Submission&body=First Name: ${formData.firstName}%0ALast Name: ${formData.lastName}%0AEmail: ${formData.email}%0AMessage: ${formData.message}`;
    window.location.href = mailtoLink;
  };

  return (
    <div className={`contact-container ${isMenuOpen ? 'contact-container-menu-open' : ''}`}>
      <div className={`contact-section ${isMenuOpen ? 'contact-section-menu-open' : ''}`}>
        <form className="contact-section-form" onSubmit={handleSubmit}>
          <div className="contact-section-form-heading">
            <h1>{t('getInTouch')}</h1>
          </div>
          <div className="contact-section-form-body">
            <input
              type="text"
              name="firstName"
              placeholder={t('firstName')}
              value={formData.firstName}
              onChange={handleChange}
              className="contact-input"
              required
            />
            <input
              type="text"
              name="lastName"
              placeholder={t('lastName')}
              value={formData.lastName}
              onChange={handleChange}
              className="contact-input"
              required
            />
            <input
              type="email"
              name="email"
              placeholder={t('email')}
              value={formData.email}
              onChange={handleChange}
              className="contact-input"
              required
            />
            <textarea
              name="message"
              placeholder={t('yourMessage')}
              value={formData.message}
              onChange={handleChange}
              className="contact-textarea"
              required
            ></textarea>
          </div>
          <div className="contact-section-form-button">
            <Button type="submit">{t('submit')}</Button>
          </div>
        </form>
        <div className="contact-section-links">
          <div className="contact-section-email">
            <img src="/images/logo_gray.png" alt="Logo" />
            <a href="mailto:lambadacouncil@gmail.com">
              <FontAwesomeIcon icon={faEnvelope} /> lambadacouncil@gmail.com
            </a>
          </div>
          <div className="contact-section-bottom">
            <a href="https://instagram.com/lambadacouncil/" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a href="https://www.facebook.com/profile.php?id=61565092723909" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faFacebookF} />
            </a>
            <a href="https://www.youtube.com/@LambadaWorldDanceCouncil" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faYoutubeSquare} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
